import { Action, IAlertBaseCount } from 'shared/interface';
import * as actionTypes from 'store/action-types';

const alertCount = (state = {} as IAlertBaseCount, action: Action) => {
	switch (action.type) {
		case actionTypes.UPDATE_ALERT_COUNT:
			return { ...state, ...action.payload };
		default:
			return state;
	}
};

export default alertCount;
